import { ApolloProvider, NormalizedCacheObject } from '@apollo/client'
import { useToast } from '@ticketswap/solar'
import { ReactNode } from 'react'
import { useApollo } from '~/lib/apolloClient'
import { useTranslation } from '~/components/TranslationContext'

interface Props {
  children: ReactNode
  initialState: NormalizedCacheObject
}

export const GraphQLProvider = ({ children, initialState }: Props) => {
  const { notify } = useToast()
  const { t } = useTranslation()
  const apolloClient = useApollo(initialState, notify, t)

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}
